var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraPriority({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24609 1.03516L12.4688 6.3125C12.7422 6.55859 12.7422 6.96875 12.4688 7.21484C12.2227 7.48828 11.8125 7.48828 11.5664 7.21484L6.75391 2.42969L1.96875 7.21484C1.72266 7.48828 1.3125 7.48828 1.06641 7.21484C0.792969 6.96875 0.792969 6.55859 1.06641 6.28516L6.31641 1.03516C6.5625 0.789062 6.97266 0.789062 7.24609 1.03516ZM12.4961 11.5352L12.4688 11.5625C12.7422 11.8086 12.7422 12.2188 12.4688 12.4648C12.2227 12.7383 11.8125 12.7383 11.5664 12.4648L6.75391 7.67969L1.96875 12.4648C1.72266 12.7383 1.3125 12.7383 1.06641 12.4648C0.792969 12.2188 0.792969 11.8086 1.06641 11.5352L6.31641 6.28516C6.5625 6.03906 6.97266 6.03906 7.24609 6.28516L12.4961 11.5352Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraPriority);
export default __webpack_public_path__ + "static/media/jira-priority.26762e328e95c945512b721424431e41.svg";
export { ForwardRef as ReactComponent };